const SWAP_LINKS_GETTERS = {
  loading: 'swapLinks/isLoading',
  actionLoading: 'swapLinks/actionLoading',
  totalPartnerShare: 'swapLinks/totalPartnerShare',
  stats: 'swapLinks/stats',
  sorting: 'swapLinks/sorting',
}

const SWAP_LINKS_DISPATCHERS = {
  createSwapApp: 'swapLinks/createSwapApp',
  resetStore: 'swapLinks/resetStore',
  changePage: 'swapLinks/changePage',
  getSwapStats: 'swapLinks/getSwapStats',
  getSwapApps: 'swapLinks/getSwapApps',
  updateSwapApp: 'swapLinks/updateSwapApp',
  deleteSwapApps: 'swapLinks/deleteSwapApps',
  onSelectSort: 'swapLinks/onSelectSort',
  resetPage: 'swapLinks/resetPage',
  _updateWidgetInTable: 'swapLinks/_updateWidgetInTable',
}

export { SWAP_LINKS_DISPATCHERS, SWAP_LINKS_GETTERS }
